import React from "react";
import { Typography, CircularProgress, styled, Box } from "@mui/material";
import { useSelector } from "react-redux";

import { getNewPrice, getPlanPrice } from "../utils";
import { IntlFormatUSD } from "../../../../utils";
import { ICode } from "../types";

const StyledTypography = styled(Typography)({
  fontWeight: "bold",
  fontSize: "17px",
  display: "inline-block",
});

interface IProps {
  isNewPrice: boolean;
  values: ICode;
}
const NewPrice = ({ values, isNewPrice }: IProps): React.ReactElement | null => {
  const plansData = useSelector((state) => state.plans);

  const newPrice = getNewPrice({ plans: plansData.data.plans, code: values });
  const planPrice = getPlanPrice(plansData.data.plans, values.plan) / 100;
  const planPriceWithDiscount = planPrice - newPrice;

  if (values.plan <= 0) {
    return null;
  }

  if (plansData.loading) {
    return (
      <Box display="flex" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="column">
      <Typography component="span">
        Price of plan:
        <StyledTypography>{IntlFormatUSD(planPrice)}</StyledTypography>
      </Typography>
      <Typography component="span">
        Discounts amount:
        {isNewPrice ? (
          <StyledTypography>{IntlFormatUSD(newPrice)}</StyledTypography>
        ) : (
          <StyledTypography>{IntlFormatUSD(planPriceWithDiscount)}</StyledTypography>
        )}
      </Typography>
      <Typography component="span">
        Total price:{" "}
        {isNewPrice ? (
          <StyledTypography>{IntlFormatUSD(planPriceWithDiscount)}</StyledTypography>
        ) : (
          <StyledTypography>{IntlFormatUSD(newPrice)}</StyledTypography>
        )}
      </Typography>
    </Box>
  );
};

export default NewPrice;
